module.exports = __webpack_public_path__ + "img/2020_13.984e5e9e.jpg";